import { StandardEvents } from '@shopify/events';
(() => {
 const init = () => document.querySelectorAll('.wb-header').forEach(header => {
  if(header.dataset.scrollReady)return;
  header.dataset.scrollReady='true';
  const row=header.querySelector('.wb-header-main'),slot=header.querySelector('.wb-header-main-slot');
  if(!row||!slot)return;
  const desktop=matchMedia('(min-width:750px)');
  const wrapper=header.closest('.page-wrapper');
  const position=()=>wrapper&&['auto','scroll'].includes(getComputedStyle(wrapper).overflowY)?wrapper.scrollTop:scrollY;
  let last=Math.max(0,position()),travel=0,frame=0,feedbackUntil=0,feedbackTimer;
  const measure=()=>{
   if(!header.classList.contains('wb-header--floating'))header.style.setProperty('--wb-main-height',`${row.offsetHeight}px`);
  };
  const update=()=>{
   frame=0;
   const y=Math.max(0,position()),delta=y-last;last=y;
   if(header.getBoundingClientRect().bottom>=0){
    header.classList.remove('wb-header--floating','wb-header--revealed');row.inert=false;travel=0;measure();return;
   }
   header.classList.add('wb-header--floating');
   travel=Math.sign(delta)===Math.sign(travel)?travel+delta:delta;
   if(!desktop.matches||performance.now()<feedbackUntil||travel<=-6||row.contains(document.activeElement)||header.querySelector('.wb-mobile-shop[open]'))header.classList.add('wb-header--revealed');
   else if(travel>=6)header.classList.remove('wb-header--revealed');
   row.inert=!header.classList.contains('wb-header--revealed');
  };
  const revealFeedback=()=>{
   if(!header.isConnected||header.getBoundingClientRect().bottom>=0)return;
   feedbackUntil=performance.now()+2500;travel=0;last=Math.max(0,position());
   header.classList.add('wb-header--floating','wb-header--revealed');row.inert=false;
   clearTimeout(feedbackTimer);feedbackTimer=setTimeout(update,2550);
  };
  document.addEventListener('wb:wishlist-added',revealFeedback);
  document.addEventListener('wb:cart-added',revealFeedback);
  document.addEventListener(StandardEvents.cartLinesUpdate,event=>{
   if(event.action!=='add')return;
   event.promise?.then(result=>{if(result&&!result.detail?.didError)revealFeedback();}).catch(()=>{});
  });
  const menuButton=header.querySelector('.wb-floating-menu-button'),mobileMenu=header.querySelector('.wb-mobile-shop');
  if(menuButton&&mobileMenu){
   menuButton.addEventListener('click',event=>{event.stopPropagation();mobileMenu.open=!mobileMenu.open;});
   mobileMenu.addEventListener('toggle',()=>menuButton.setAttribute('aria-expanded',String(mobileMenu.open)));
   header.addEventListener('keydown',e=>{if(e.key==='Escape'&&mobileMenu.open){mobileMenu.open=false;menuButton.focus();}});
  }
  measure();
  const onScroll=()=>{if(!frame)frame=requestAnimationFrame(update);};
  window.addEventListener('scroll',onScroll,{passive:true});
  wrapper?.addEventListener('scroll',onScroll,{passive:true});
  window.addEventListener('resize',()=>{header.classList.remove('wb-header--floating','wb-header--revealed');row.inert=false;measure();update();},{passive:true});
  desktop.addEventListener('change',update);
  update();
 });
 init();document.addEventListener('shopify:section:load',init);
})();
